"use strict";
exports.__esModule = true;
$("#dataview").emdataview({
    dataurl: {
        hostname: "datacenter",
        url: "api/data/v1/get",
        params: {
            reportName: "RPT_IF_BILLBORAD_SS",
            columns: "ALL",
            source: "IFBILLBOARD",
            sortColumns: "TRADE_DATE",
            sortTypes: "-1",
            client: "WEB",
            filter: "(SECURITY_CODE=\"" + pagedata.typecode + "\")(ORG_CODE=\"" + pagedata.code + "\")",
            token: "894050c76af8597a853f5b408b759f5d"
        },
    },
    columns: {
        TRADE_DATE: emfield.date,
        BUY_VOLUME: emfield.string,
        SELL_VOLUME: emfield.string,
        BUY_POSITION: emfield.string,
        SELL_POSITION: emfield.string,
        BUY_VOLUME_CHANGE: { formatter: { num: 0, omit: false, showcolor: true } },
        SELL_VOLUME_CHANGE: { formatter: { num: 0, omit: false, showcolor: true } },
        BUY_POSITION_CHANGE: { formatter: { num: 0, omit: false, showcolor: true } },
        SELL_POSITION_CHANGE: { formatter: { num: 0, omit: false, showcolor: true } },
        BUY_VOLUME_NET: { formatter: { num: 0, omit: false } },
        SELL_VOLUME_NET: { formatter: { num: 0, omit: false } },
        BUY_POSITION_NET: { formatter: { num: 0, omit: false } },
        SELL_POSITION_NET: { formatter: { num: 0, omit: false } },
        BUY_VOLUME_RATIO: { formatter: { num: 2, omit: false, zoom: 2, fix: "%" } },
        SELL_VOLUME_RATIO: { formatter: { num: 2, omit: false, zoom: 2, fix: "%" } },
        BUY_POSITION_RATIO: { formatter: { num: 2, omit: false, zoom: 2, fix: "%" } },
        SELL_POSITION_RATIO: { formatter: { num: 2, omit: false, zoom: 2, fix: "%" } }
    }
});
